import useApiMutation from '@hooks/mutations/useApiMutation';

function useResetPasswordMutation(options) {
  return useApiMutation('post', `/v1/forgotten/reset`, options);
}

export default useResetPasswordMutation;
